/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https:/
 * */
 export const environment = {
	production: true,
	isMockEnabled: false, // You have to switch this, when your real back-end is done
	apiUrl: "https://bdcg-api.theideators.net/api/",//"https://sms-api.theideators.net/api/" Production --> https://bdcg-api.theideators.net/api/ Local --> "http://localhost:7077/api/"
	rootUrl: "https://bdcg-api.theideators.net/",//"https://sms-api.theideators.net/", Production --> "https://bdcg-api.theideators.net/" Local --> "http://localhost:7077/"
  PassportId: 146,
	DrivingLicenseId: 147,
	NationalIDCardId: 148,
	TaxCertificateId: 149,
  ApplicationPhotoId: 155,
  AppointmentTypeSubmission: 60101,
  AppointmentTypeDelivery: 60102,
  GatewayUrl: "https://gateway.moneris.com/chktv2/request/request.php",//https://gatewayt.moneris.com/chktv2/request/request.php" --> Prod CheckOut MONERIS "https://gatewayt.moneris.com/chktv2/request/request.php" --> qa CheckOut MONERIS		//https://www3.moneris.com/HPPDP/index.php -> Production 	|| https://esqa.moneris.com/HPPDP/index.php  -> Demo
  GatewayEnvironment: "prod", // prod --> production; qa --> QA
  CheckOutId: "chktFLQEA29604",									//BPY7H29604   -> Production 								|| chkt37558tore3   -> Demo
  PSStoreId: "BPY7H29604",									//BPY7H29604   -> Production 								|| PU7BQtore3   -> Demo
  HppKey: "hpAAEI3H6ADI",										//hpAAEI3H6ADI -> Production 								|| hpJJAZ186I2A -> Demo
  HostingUrl: "https://service.bdcgtoronto.ca/"				//https://service.bdcgtoronto.ca/ -> Production             || https://bangladesh-214214.firebaseapp.com/ -> Demo
};
